/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { ColCard } from "../../../../components/ContentLayout";
import Button from "../../../../components/Button";
import { get, isEmpty } from "lodash-es";
import {
  deleteAdditionalInfosDetail,
  getAdditionalInfos,
  modifyAdditionalInfosDetail,
} from "../../../../apis/companies/company-infos";
import { dateToViewFormat } from "../../../../utils/date";
import NoData from "../../../../components/NoData/NoData";
import Loading from "../../../../components/Loading";
import AdditonalDetail from "./AdditionalDetail";
import { onLoadMultiImage } from "../../../../utils/image";
import IconButton from "../../../../components/Button/IconButton";
import DeleteIcon from "../../../../assets/images/icon/delete-icon.svg";
import { viewLoading } from "../../../../utils/loading";
import Profile from "../../../../components/Profile";
import { classnames } from "../../../../utils/text";

import Icon from "../../../../components/Icon";
import DownloadIcon from "../../../../assets/images/icon/download-icon.svg";
import { download } from "../../../../utils/download";

const AdditionalTable = ({
  type,
  mode = "detail",
  headerButtons,
  open,
  setOpen,
}) => {
  const tableHeight = 200;
  const [additionalInfoList, setAdditionalInfoList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    submit();
  }, []);

  const submit = () => {
    // type 1 - 통장사본, type 2 - 인감, type 3 - 사업자등록증
    setIsLoading(true);
    getAdditionalInfos(type)
      .then((res) => {
        setAdditionalInfoList(res.data.additionalInfos);
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => setIsLoading(false));
  };

  const getTableTitle = (type) => {
    let title = "";

    switch (type) {
      case 1:
        title = "통장사본 관리";
        break;
      case 2:
        title = "인감 관리";
        break;
      case 3:
        title = "사업자등록증 관리";
        break;
      default:
        break;
    }
    return title;
  };

  const handleOnImageClick = (data) => {
    
    if (mode.mode === "detail") {
      data.file.fileUrl = data.file.url;
      onLoadMultiImage([data.file], 0)
    }
  };

  const handleOnAvailable = (data) => {
    
    if (mode.mode === "detail") return;

    if (isEmpty(data.memo)) {
      delete data.memo
    }

    if (data.available === 1) {
      data.available = 0
    } else if (data.available === 0) {
      data.available = 1
    } else {
      return
    }

    viewLoading(true);
    modifyAdditionalInfosDetail(data.idx, {type, fileIdx: data.file.idx, ...data})
      .then(() => {
        submit();
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        viewLoading(false);
      });
  }

  const handleOnRemove = (data) => {
    viewLoading(true);
    deleteAdditionalInfosDetail(data.idx)
      .then(() => {
        submit();
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        viewLoading(false);
      });
  };

  return (
    <>
      <ColCard cardBody={{ className: "p-0" }}>
        <div className="card-header">
          <span className="additional-card-title">{getTableTitle(type)}</span>
          <div className="button-wrap">
            {!isEmpty(headerButtons) &&
              headerButtons.map((button, idx) => (
                <Button {...button} key={idx} className="margin-left-8" />
              ))}
          </div>
        </div>
        <div className="additional-card-body">
          {isLoading ? (
            <Loading minHeight={tableHeight} />
          ) : isEmpty(additionalInfoList) ? (
            <NoData />
          ) : (
            additionalInfoList.map((data, idx) => (
              <div className="list-wrapper" key={idx}>
                <div className="list-item">
                  <div
                    className="image-wrap"
                    // style={{ backgroundImage: `url(${get(data, "file.url")})` }}
                    //onClick={() => handleOnClick(data)}
                    onClick={() => handleOnImageClick(data)}
                  >
                    <img className={classnames("additional-img", { sign: type === 2 })} src={get(data, "file.url")} alt={get(data, "file.url")} />
                    {type === mode.type && mode.mode === "modify" && (
                      <IconButton
                        icon={DeleteIcon}
                        className="delete-btn"
                        onClick={() => handleOnRemove(data)}
                      />
                    )}
                    {type !== 1 && type === mode.type && mode.mode === "modify" ? (
                      (get(data, "available") === 1 ? (
                        <span className="available-tag true" onClick={() => handleOnAvailable(data)}>유효</span>
                      ) : (
                        <span className="available-tag false" onClick={() => handleOnAvailable(data)} >만료</span>
                      ))
                    ) : ( type !== 1 &&
                      (get(data, "available") === 1 ? (
                        <span className="available-tag true">유효</span>
                      ) : (
                        <span className="available-tag false">만료</span>
                      ))
                    )}
                  </div>
                  <div className="item-info">
                    {type !== 2 ? (
                      <Button
                        onClick={() => download(get(data, "file.url"), get(data, "file.originalName") || get(data, "file.name"))}
                        //size="sm"
                        color="text"
                        className="download-all-button"
                      >
                         {get(data, "title")}  <Icon src={DownloadIcon} />
                      </Button>
                    ) : (
                      <div className="item-title"> {get(data, "title")} </div>
                    )}
                    <div className="item-user-info">
                      <Profile employeeIdx={get(data, "employee.idx")} />
                    </div>
                  </div>
                  <p className="created-date">
                    {dateToViewFormat(data.createdTime)}
                  </p>
                </div>
              </div>
            ))
          )}
        </div>
      </ColCard>
      <AdditonalDetail
        type={type}
        open={open}
        setOpen={setOpen}
        submit={submit}
      />
    </>
  );
};

export default AdditionalTable;
